import pathnameSelector from 'app/Router/selectors/pathname';
import payloadSelector from 'app/Router/selectors/payload';
import typeSelector from 'app/Router/selectors/type';
import {
  componentHoveringSelector,
  componentSelectedSelector,
  mwpIFrameSelector
} from 'app/PreviewPane/selector';

import connect from 'utils/store/connect';

import App from './components/App';
import applicationModeSelector from './selectors/applicationMode';

/**
 * map redux state to react component properties
 * @param {object} state - redux state object
 * @returns {object} react props
 */
const mapStateToProps = state => ({
  applicationMode: applicationModeSelector(state),
  componentSelected: componentSelectedSelector(state),
  componentHovering: componentHoveringSelector(state),
  mwpIFrameRef: mwpIFrameSelector(state),
  pathname: pathnameSelector(state),
  pathType: typeSelector(state),
  payload: payloadSelector(state)
});

export default connect(mapStateToProps, null)(App);
